// import external libraries
import { useQuery } from 'react-query';
import dayjs from 'dayjs';

// import hooks
import { requests } from 'RestAPIs/rapini';

// import types
import type { Patient } from './types';
import type { ClientResponse } from 'generated/index';

export const useGetPatientDetails = (patient: Patient | null) => {
  return useQuery(
    ['patient-details', patient?.entityId],
    async (): Promise<Patient | null> => {
      const response = await requests.getPlanning({
        planningEntityIdentifiers: [
          {
            entityId: patient!.entityId!,
            planningEntityType: 'CLIENT'
          }
        ],
        startDate: dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
        endDate: dayjs().add(1, 'year').format('YYYY-MM-DD')
      });

      const clientEntity = response.planningEntities.find(
        (entity) =>
          entity.planningEntityIdentifier.entityId === patient!.entityId
      );

      if (!clientEntity?.planningEntity) return null;

      const client: Partial<ClientResponse> = clientEntity.planningEntity;

      return {
        ...patient!,
        displayName: client.displayName || client.nameWithInitials,
        dateOfBirth: client.dateOfBirth,
        treatments: client.treatments || []
      };
    },
    { enabled: !!patient?.entityId }
  );
};
